exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.upload-files{color:gray;padding:5px}.cursor-help{cursor:help}a.v-tabs__item:hover{text-decoration:none!important;font-weight:bolder}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5937b6cd","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/assembly/powersaudit.vue
// module id = wYa+
// module chunks = 2